const RELATED_OBJECT_ROUTES = {
  leave: '/workforce-management?tab=leave',
  expense: '/workforce-management?tab=expenses',
  attendance: '/workforce-management?tab=attendance',
};

/** Page a notification about a leave/expense/attendance record should open, if any. */
export const getRelatedObjectRoute = (notification) => RELATED_OBJECT_ROUTES[notification?.related_object_type] || null;

export default getRelatedObjectRoute;
